import styled from '@emotion/styled'
import { memo } from 'react'
import { ChainItem } from './ChainItem'
import { V3WithdrawalChainIds } from './constants'

const Wrap = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 64px 24px;
`
const PageTitle = styled('h1')`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: rgba(255, 255, 255, 1);
  padding: 48px 0 40px;
`
const ChainList = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`
export const V3WithdrawalView = memo(() => {
  return (
    <Wrap>
      <PageTitle>Withdrawal</PageTitle>
      <ChainList>
        {V3WithdrawalChainIds.map((chainId) => {
          return <ChainItem key={chainId} chainId={chainId} />
        })}
      </ChainList>
    </Wrap>
  )
})
